export default "__VITE_ASSET__B922Utvy__"